<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
import router from '@/routes/router';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/empresas`;
const token = utilsService.getToken();

const empresaService = {
  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if(!response) throw error;
      
      response.data.paisID = response.data.paisID == 0 ? null : response.data.paisID;
      response.data.regionID = response.data.regionID == 0 ? null : response.data.regionID;
      response.data.comunaID = response.data.comunaID == 0 ? null : response.data.comunaID;
      return response.data;

    } catch (error) {
      router.push('/error');
    }
  },

  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getUsersByEmpresa(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}/users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getMaterialesByEmpresa(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}/materiales`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getOptions() {
    try {
      const response = await axios.get(`${apiUrl}/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getChoferesByEmpresa(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}/choferes`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };
      form.paisID = form.paisID || 0;
      form.industriaID = form.industriaID || 0;
      form.sectorID = form.sectorID || 0;
      form.regionID = form.regionID || 0;
      form.comunaID = form.comunaID || 0;

      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async update(formRaw, id) {
    try {
      const form = { ...formRaw };

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  }
};

export default empresaService;
</script>
